import { DismissToast } from 'common/ToastMessage'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { ScheduledPost, ScheduledPostsClient } from 'api/clients/ScheduledPostsClient'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useRef } from 'react'
import { useQueryClient, useMutation } from 'react-query'
import { useFinderRefresh } from 'screens/Finder/hooks/useFinderRefresh'
import { scheduledPostsKeys } from './scheduledPostsKeys'

type CreateScheduledPostOptions = {
  suppressToast?: boolean
  onSuccess?: (data: ScheduledPost) => void
}

export const useCreateScheduledPost = (provider?: ExternalIntegrationEnum, options?: CreateScheduledPostOptions) => {
  const loadingMessageRef = useRef<DismissToast | undefined>()
  const queryClient = useQueryClient()
  const refreshFinder = useFinderRefresh()
  const workspaceId = useCurrentWorkspaceId()
  const suppressToast = options?.suppressToast

  return useMutation(ScheduledPostsClient.create, {
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries(scheduledPostsKeys.article(data.scheduled_post?.source_id))
      queryClient.invalidateQueries(scheduledPostsKeys.calendar(workspaceId))
      queryClient.invalidateQueries(scheduledPostsKeys.unscheduledArticles)
      loadingMessageRef.current?.()
      refreshFinder()
      if (!suppressToast) {
        showToastMessage(`${provider} post successfully scheduled`, 'success')
      }

      options?.onSuccess?.(data.scheduled_post)
    },
    onError: () => {
      loadingMessageRef.current?.()
      if (!suppressToast) {
        showToastMessage(`Unable to schedule ${provider} post`, 'error')
      }
    },
    onMutate: () => {
      if (!suppressToast) {
        loadingMessageRef.current = showToastMessage(`Scheduling ${provider} post...`, 'loading')
      }
    },
  })
}
